<template>
<div>
    <!-- modal -->
    <b-modal id="officialFeeFormModal" centered size="xl" no-close-on-backdrop ref="officialFeeFormModal" :title=" $t('officialFee.info')" @close="clear()" cancel-variant="outline-secondary" :cancel-title=" $t('others.cancel_title')" @ok.prevent="addOrUpdate" :ok-title=" $t('others.ok_title')">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-lg-3" v-if="searchControl">
                    <b-form style="margin-top: 0.2em">
                        <validation-provider :name="$t('officialFee.record_no')" #default="{ errors }" rules="required">
                            <b-form-group :label="$t('officialFee.record_no')" label-for="official-fee-record-no-input" :state="errors.length > 0 ? false : null">
                                <v-select id="official-fee-record-no-input" size="sm" v-model="recordName" label="recordName" @input="setValues" @search="onFastSearch" :options="searchRecordOption.map(option => ({ ...option, recordName: option.recordName}))">
                                </v-select>
                                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form-group>
                        <validation-provider :name="$t('officialFee.currency')" rules="required" v-slot="{ errors }">
                            <label>{{ $t('officialFee.currency')  }}</label>
                            <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="currencySelect" value-field="id" text-field="name" :options="currencyOption" />
                            <small class="text-danger">{{ errors[0]  }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form-group>
                        <label>{{ $t('officialFee.credit_card')  }}</label>
                        <b-form-select size="sm" v-model="creditCardSelect" value-field="id" text-field="name" :options="creditCardOption" />
                    </b-form-group>
                </b-col>

                <b-col class="col-md-3">
                    <label for="officialFee-isPaymentOtherInstitutions-input">{{ $t('officialFee.is_payment_other_institutions') }}</label>
                    <br>
                    <b-form-checkbox class="custom-control-success" name="officialFee-isPaymentOtherInstitutions-input" id="jofficialFee-isPaymentOtherInstitutions-input" v-model="isPaymentOtherInstitutions" switch>
                        <span class="switch-icon-left">
                            <feather-icon icon="CheckIcon" />
                        </span>
                        <span class="switch-icon-right">
                            <feather-icon icon="XIcon" />
                        </span>
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <label for="official-fee-receipt-date-input">{{ $t('officialFee.receipt_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="1" v-model="receiptDate"></CustomDatePicker>
                </b-col>
                <b-col class="col-lg-3">
                    <label for="official-fee-receipt-no-input">{{ $t('officialFee.receipt_no') }}</label>
                    <validation-provider #default="{ errors }" :name="$t('officialFee.receipt_no')" rules="required">
                        <b-form-input size="sm" id="official-fee-receipt-no-input" :placeholder="$t('officialFee.receipt_no')" v-model="receiptNo" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
                <b-col class="col-lg-3">
                    <label for="official-fee-date-input">{{ $t('officialFee.date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="date"></CustomDatePicker>
                </b-col>
                <b-col class="col-lg-3">
                    <label>{{ $t('officialFee.official_fee_type')  }}</label>
                    <b-form-select size="sm" v-model="officialFeeTypeSelect" value-field="id" text-field="name" :options="officialFeeTypeOption" />
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <label for="official-fee-application-no-input">{{ $t('officialFee.application_no') }}</label>
                    <b-form-input size="sm" id="official-fee-application-no-input" :placeholder="$t('officialFee.application_no')" v-model="applicationNo" />
                </b-col>
                <b-col class="col-lg-3">
                    <label for="official-fee-name-input">{{ $t('officialFee.name') }}</label>
                    <validation-provider #default="{ errors }" :name="$t('officialFee.name')" rules="required">
                        <b-form-input size="sm" id="official-fee-name-input" :placeholder="$t('officialFee.name')" v-model="name" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
                <b-col class="col-lg-3">
                    <label for="official-fee-price-input">{{ $t('officialFee.price') }}</label>
                    <b-form-input size="sm" id="official-fee-price-input" :placeholder="$t('officialFee.price')" v-model="price" />
                </b-col>
                <b-col class="col-lg-3">
                    <label for="official-fee-refund-status-input">{{ $t('officialFee.official_fee_refund_status') }}</label>
                    <b-form-select size="sm" v-model="officialFeeRefundStatusSelect" value-field="id" text-field="name" :options="officialFeeRefundStatusOption" />
                </b-col>
            </b-row>
            <b-row>
                <b-col v-if="this.isPaymentOtherInstitutions == false" class="col-lg-3 mt-1">
                    <label for="official-fee-official-fee-input">{{ $t('officialFee.official_fee') }}</label>
                    <b-form-input size="sm" id="official-fee-official-fee-input" :placeholder="$t('officialFee.official_fee')" v-model="officialFee" />
                </b-col>
                <b-col v-if="this.isPaymentOtherInstitutions == false" class="col-lg-3 mt-1">
                    <label for="official-fee-tpmk-base-official-fee-input">{{ $t('officialFee.tpmk_base_official_fee') }}</label>
                    <b-form-input size="sm" id="official-fee-tpmk-base-official-fee-input" :placeholder="$t('officialFee.tpmk_base_official_fee')" v-model="tpmkBaseOfficialFee" />
                </b-col>
                <b-col v-if="this.isPaymentOtherInstitutions == false" class="col-lg-3 mt-1">
                    <label for="official-fee-tpmk-base-service-fee-input">{{ $t('officialFee.tpmk_base_service_fee') }}</label>
                    <b-form-input size="sm" id="official-fee-tpmk-base-service-fee-input" :placeholder="$t('officialFee.tpmk_base_service_fee')" v-model="tpmkBaseServiceFee" />
                </b-col>
                <b-col v-if="this.isPaymentOtherInstitutions == false" class="col-lg-3 mt-1">
                    <label for="official-fee-tpmk-base-service-vat-input">{{ $t('officialFee.tpmk_base_service_vat') }}</label>
                    <b-form-input size="sm" id="official-fee-tpmk-base-service-vat-input" :placeholder="$t('officialFee.tpmk_base_service_vat')" v-model="tpmkBaseServiceVat" />
                </b-col>
            </b-row>

            <b-row v-if="this.isPaymentOtherInstitutions == true">
                <b-col class="col-lg-2 mt-1">
                    <label>{{ $t('officialFee.official_fee_owner_type')  }}</label>
                    <b-form-select size="sm" v-model="officialFeeOwnerTypeSelect" value-field="id" text-field="name" :options="officialFeeOwnerTypeOption" />
                </b-col>
                <b-col class="col-lg-2 mt-1">
                    <label for="official-fee-invoice-date-input">{{ $t('officialFee.invoice_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="invoiceDate"></CustomDatePicker>
                </b-col>
                <b-col class="col-lg-2 mt-1">
                    <label for="official-fee-invoice-no-input">{{ $t('officialFee.invoice_no') }}</label>
                    <b-form-input size="sm" id="official-fee-invoice-no-input" :placeholder="$t('officialFee.invoice_no')" v-model="invoiceNo" />
                </b-col>
                <b-col class="col-lg-2 mt-1">
                    <label for="official-fee-name-input">{{ $t('officialFee.name') }}</label>
                    <b-form-input size="sm" id="official-fee-name-input" :placeholder="$t('officialFee.name')" v-model="employeeName" disabled />
                </b-col>
                <b-col class="col-lg-2 mt-1">
                    <label>{{ $t('officialFee.official_fee_payment_institution')  }}</label>
                    <b-form-select size="sm" v-model="paymentInstutionSelect" value-field="id" text-field="name" :options="paymentInstutionOption" />
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <label class="mt-2" for="official-fee-note-input">{{ $t('officialFee.note') }}</label>
                    <b-form-textarea id="official-fee-note-input" :placeholder=" $t('officialFee.note')" rows="3" v-model="note" />
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getOfficialFeeList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            currencySelect: 0,
            currencyOption: [],
            creditCardSelect: 0,
            creditCardOption: [],
            isPaymentOtherInstitutions: false,
            receiptDate: null,
            date: null,
            invoiceDate: null,
            receiptNo: '',
            officialFeeTypeSelect: 0,
            officialFeeTypeOption: [],
            applicationNo: '',
            name: '',
            applicationNo: '',
            price: '',
            officialFee: '',
            tpmkBaseOfficialFee: '',
            tpmkBaseServiceFee: '',
            tpmkBaseServiceVat: '',
            employeeName: '',
            officialFeeRefundStatusSelect: 0,
            officialFeeRefundStatusOption: [],
            officialFeeOwnerTypeSelect: 0,
            officialFeeOwnerTypeOption: [],
            invoiceNo: '',
            note: '',
            searchControl: true,
            searchRecordOption: [],
            recordName: '',
            moduleId: 0,
            recordId: 0,
            paymentInstutionOption: [],
            paymentInstutionSelect: 0,
        }
    },
    methods: {
        clear() {
            this.searchRecordOption = []
            this.recordName = ''
            this.moduleId = 0
            this.recordId = 0
            this.searchControl = true
            this.isPaymentOtherInstitutions = false
        },
        onFastSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.fastSearch(loading, search, this);
            }
        },
        fastSearch(loading, search) {
            if (search.length > 2) {
                const data = {
                    recordNo: search,
                    isOnlyOperationRecord: true
                }

                const controller = {
                    name: 'Module',
                    actionName: 'GetRecordListByRecordNo'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.searchRecordOption = response.data.recordList
                    loading(false)
                })
            }
        },
        setValues(event) {
            this.moduleId = event.moduleId
            this.recordId = event.recordId
        },
        showInfo(id) {
            if (id > 0) {
                this.searchControl = false
            }
            this.$refs['officialFeeFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'OfficialFee'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.currencyOption = response.data.currencyList
                    if (this.id == 0) {
                        this.currencySelect = 4
                    } else {
                        this.currencySelect = response.data.officialFee.currencyId
                    }

                    this.officialFeeRefundStatusOption = response.data.officialFeeRefundStatusList
                    this.officialFeeRefundStatusSelect = response.data.officialFee.officialFeeRefundStatusId
                    this.isPaymentOtherInstitutions = response.data.officialFee.isPaymentOtherInstitutions
                    this.employeeName = response.data.officialFee.employee
                    this.tpmkBaseServiceVat = response.data.officialFee.tpmkBaseServiceVat
                    this.tpmkBaseServiceFee = response.data.officialFee.tpmkBaseServiceFee
                    this.tpmkBaseOfficialFee = response.data.officialFee.tpmkBaseOfficialFee
                    this.officialFee = response.data.officialFee.officialFeeValue
                    this.price = response.data.officialFee.price
                    this.applicationNo = response.data.officialFee.applicationNo
                    this.name = response.data.officialFee.name
                    this.applicationNo = response.data.officialFee.applicationNo
                    this.officialFeeTypeOption = response.data.officialFeeTypeList
                    this.officialFeeTypeSelect = response.data.officialFee.officialFeeTypeId
                    this.date = response.data.officialFee.date
                    this.receiptNo = response.data.officialFee.receiptNo
                    this.receiptDate = response.data.officialFee.receiptDate
                    this.creditCardSelect = response.data.officialFee.creditCardId
                    this.moduleId = response.data.officialFee.moduleId,
                        this.recordId = response.data.officialFee.recordId,
                        this.officialFeeRefundStatusOption.splice(0, 0, this.$nullSelected('name'))
                    this.officialFeeTypeOption.splice(0, 0, this.$nullSelected('name'))
                    this.creditCardOption = response.data.creditCardList
                    this.officialFeeOwnerTypeOption = response.data.officialFeeOwnerTypeList
                    this.officialFeeOwnerTypeSelect = response.data.officialFee.officialFeeOwnerTypeId
                    this.invoiceDate = response.data.officialFee.invoiceDate
                    this.invoiceNo = response.data.officialFee.invoiceNo
                    this.note = response.data.officialFee.note
                    this.paymentInstutionOption = response.data.officialFeePaymentInstitutionList
                    this.officialFeeOwnerTypeOption.splice(0, 0, this.$nullSelected('name'))
                    this.creditCardOption.splice(0, 0, this.$nullSelected())
                    this.paymentInstutionOption.splice(0, 0, this.$nullSelected("name"))
                } else {
                    this.$bvModal.hide('officialFeeFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                currencyId: this.currencySelect,
                officialFeeRefundStatusId: this.officialFeeRefundStatusSelect,
                isPaymentOtherInstitutions: this.isPaymentOtherInstitutions,
                employeeId: localStorage.getItem('EmployeeId'),
                tpmkBaseServiceVat: this.tpmkBaseServiceVat,
                tpmkBaseServiceFee: this.tpmkBaseServiceFee,
                tpmkBaseOfficialFee: this.tpmkBaseOfficialFee,
                officialFeeValue: this.officialFee,
                price: this.price,
                applicationNo: this.applicationNo,
                name: this.name,
                applicationNo: this.applicationNo,
                officialFeeTypeId: this.officialFeeTypeSelect,
                receiptNo: this.receiptNo,
                date: this.date,
                receiptDate: this.receiptDate,
                officialFeeOwnerTypeId: this.officialFeeOwnerTypeSelect,
                invoiceDate: this.invoiceDate,
                invoiceNo: this.invoiceNo,
                note: this.note,
                creditCardId: this.creditCardSelect,
                moduleId: this.moduleId,
                recordId: this.recordId,
                paymentInstutionId: this.paymentInstutionSelect
            }
            const controller = {
                name: 'OfficialFee'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.id = response.data.officialFeeId
                            this.getOfficialFeeList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
